import { render, staticRenderFns } from "./CreateExamineInfo.vue?vue&type=template&id=c38f8026&scoped=true&"
import script from "./CreateExamineInfo.vue?vue&type=script&lang=js&"
export * from "./CreateExamineInfo.vue?vue&type=script&lang=js&"
import style0 from "./CreateExamineInfo.vue?vue&type=style&index=0&id=c38f8026&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38f8026",
  null
  
)

component.options.__file = "CreateExamineInfo.vue"
export default component.exports